import React, { PropsWithChildren, ReactNode } from "react";
import Skeleton from "react-loading-skeleton";

const LoadingContext = React.createContext<boolean>(false);

interface LoadingSkeletonProviderProps {
  loading?: boolean;
}

export const LoadingSkeletonProvider: React.FC<PropsWithChildren<LoadingSkeletonProviderProps>> = ({ loading = false, children }: PropsWithChildren<LoadingSkeletonProviderProps>): JSX.Element => {
  return <LoadingContext.Provider value={loading}>{children}</LoadingContext.Provider>;
};

// eslint-disable-next-next
export const LoadingSkeleton: React.FC<PropsWithChildren<object>> = ({ children }: PropsWithChildren<object>): JSX.Element => {
  let className = "";

  // if more than one child, do not render a skeleton
  if (Array.isArray(children)) {
    return (<>{children}</>);
  } else {
    // extract classname from single child
    className = (children as React.ReactElement).props.className;
  }

  return (
    <LoadingContext.Consumer>
      {(loading): ReactNode => {
        if (loading) {
          return (
            <div className={className}>
              <Skeleton />
            </div>
          );
        } else {
          return children;
        }
      }}
    </LoadingContext.Consumer>
  );
};
